import { useCallback, useEffect, useRef, useState } from 'react'

const INTERACTION_FREEZE_TIMEOUT_MS = 4000

export const useInteractionFreeze = () => {
  const [isInteracting, setIsInteracting] = useState(false)
  const timeoutRef = useRef<number | undefined>(undefined)

  const clearFreezeTimer = useCallback(() => {
    window.clearTimeout(timeoutRef.current)
  }, [])

  const handleInteractionEnd = useCallback(() => {
    clearFreezeTimer()
    timeoutRef.current = window.setTimeout(() => setIsInteracting(false), 0)
  }, [clearFreezeTimer])

  const handleInteractionStart = useCallback(() => {
    setIsInteracting(true)
    clearFreezeTimer()
    timeoutRef.current = window.setTimeout(
      () => setIsInteracting(false),
      INTERACTION_FREEZE_TIMEOUT_MS,
    )
  }, [clearFreezeTimer])

  useEffect(() => {
    const unfreeze = () => handleInteractionEnd()
    document.addEventListener('pointerup', unfreeze)
    document.addEventListener('pointercancel', unfreeze)
    return () => {
      document.removeEventListener('pointerup', unfreeze)
      document.removeEventListener('pointercancel', unfreeze)
      clearFreezeTimer()
    }
  }, [handleInteractionEnd, clearFreezeTimer])

  return { isInteracting, handleInteractionStart, handleInteractionEnd }
}
